import { render, staticRenderFns } from "./PartsCatalogueSideMenu.vue?vue&type=template&id=8731e1c4&scoped=true"
import script from "./PartsCatalogueSideMenu.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PartsCatalogueSideMenu.vue?vue&type=style&index=0&id=8731e1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8731e1c4",
  null
  
)

export default component.exports